<!-- =========================================================================================
  File Name: TheNavbar.vue
  Description: Navbar component
  Component Name: TheNavbar
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div class="relative">
    <div class="pt-6 flex justify-between">
      <router-link tag="div" to="/mainpage" class="w-9/12 vx-logo flex items-center mx-1 justify-start">
        <Logo class="w-8 mr-0 md:mr-4 fill-current text-primary" />
        <div class="d-none text-white d-md-block text-xs">
          <span class="d-block">زیرساخت ابری هایو</span>
          <span class="font-light">ویـرا ابـر، آینده جـهـان</span>
        </div>
        <b-button id="tooltip-target-2"
          class=" px-4 rounded-lg py-3 m-3 bg-h-primary-light   hover:bg-h-primary-light border-0  ">
          {{ Intl.NumberFormat('fa-IR', { maximumSignificantDigits: 3 }).format(activeUser.balance) }} تومان
        </b-button>
      </router-link>
      <div class="w-full items-center">
        <li class="nav-item flex mx-1 mt-4 justify-end items-center">
          <setting-page />
        </li>
      </div>

      <!-- </ul> -->
      <!-- add language form li18 folder -->

      <!-- <i18n />   -->

      <!-- <search-bar /> -->
      <div class="w-full d-none md:flex justify-end mx-1 items-center">
        <b-button
          @click="openHelp()"
          variant="primary" class="m-2 flex items-center ">
          <feather-icon icon="HelpCircleIcon" class="w-4 h-4 mr-2 " />
          راهنمای ثبت نام
        </b-button>
        <profile-drop-down />
        <!-- <NotificationDropDown/> -->

      </div>

    </div>

  </div>

</template>

<script>
/* eslint-disable */
import Bookmarks from './components/Bookmarks.vue'
import I18n from './components/I18n.vue'
import SearchBar from './components/SearchBar.vue'
import CartDropDown from './components/CartDropDown.vue'
import NotificationDropDown from './components/NotificationDropDown.vue'
import ProfileDropDown from './components/ProfileDropDown.vue'
import Logo from '../Logo.vue'
import SettingPage from './components/SettingPage.vue'

export default {
  name: 'the-navbar-horizontal',
  props: {
    logo: { type: String },
    navbarType: {
      type: String,
      required: true
    }
  },
  components: {
    Logo,
    Bookmarks,
    I18n,
    SearchBar,
    CartDropDown,
    NotificationDropDown,
    ProfileDropDown,
    SettingPage
  },
  methods: {
    openHelp() {
      window.open('https://haiocloud.com/%d8%a2%d9%85%d9%88%d8%b2%d8%b4-%d8%ab%d8%a8%d8%aa-%d9%86%d8%a7%d9%85-%d8%af%d8%b1-%d9%87%d8%a7%db%8c%d9%88/', '_blank')
    }
  },
  computed: {

    navbarColor() {
      let color = '#fff'
      if (this.navbarType === 'sticky') color = '#f7f7f7'
      else if (this.navbarType === 'static') {
        if (this.scrollY < 50) {
          color = '#f7f7f7'
        }
      }

      if (this.isThemedark === 'dark') {
        if (color === '#fff') {
          color = '#10163a'
        } else {
          color = '#262c49'
        }
      }

      return color
    },
    activeUser() {
      return this.$store.state.AppActiveUser
    },
    isThemedark() { return this.$store.state.theme },
    navbarStyle() { return this.navbarType === 'static' ? { transition: 'all .25s ease-in-out' } : {} },
    navbarClasses() { return this.scrollY > 5 && this.navbarType === 'static' ? null : 'd-theme-dark-light-bg shadow-none' },
    scrollY() { return this.$store.state.scrollY },
    verticalNavMenuWidth() { return this.$store.state.verticalNavMenuWidth },
    windowWidth() { return this.$store.state.windowWidth }
  }
}

</script>